import { BehaviorSubject } from 'rxjs';

export class SelectedValues {
  values: string[];
  values$ = new BehaviorSubject([]);

  constructor({ initialValues }: { initialValues: string[] }) {
    this.update(initialValues);
  }

  add(value: string): void {
    let values = [...this.values, value];
    this.update(values);
  }

  find(valueToFind: string): string {
    return this.values.find((value) => value.toLowerCase() === valueToFind?.toLowerCase());
  }

  remove(valueToRemove: string): void {
    let values = this.values.filter((value) => value !== valueToRemove);
    this.update(values);
  }

  update(values: string[]): void {
    this.values = values;
    this.values$.next(values);
  }
}
